import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import { useSurfaceShareLinksStore } from '@@/pinia/surface_share_links'
import { storeToRefs } from 'pinia'
import SurfaceSharePanelCopyItemRow from '@@/vuecomponents/SurfaceSharePanelCopyItemRow.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceSharePanelSubmissionRequestLinkSection',
  setup(__props) {

const surfaceShareLinksStore = useSurfaceShareLinksStore()
const { submissionRequestLink, isSubmissionRequestEnabled } = storeToRefs(surfaceShareLinksStore)
const { copySubmissionRequestLinkAndAlert } = surfaceShareLinksStore

return { __sfc: true,surfaceShareLinksStore, submissionRequestLink, isSubmissionRequestEnabled, copySubmissionRequestLinkAndAlert, __, OzBox, OzBoxColors, SurfaceSharePanelCopyItemRow }
}

})